import api from "PFCore/api";
import { CategoryType, EditAccountForm } from "PFModules/saas_admin/accounts/edit/edit_account.types";
import { Id, NotificationSettings } from "PFTypes";
import { Account, Category } from "PFTypes/account";

import { parsePayload } from "./account.utils";

export const fetchNotificationSettings = (): Promise<NotificationSettings> =>
  api({
    url: "notification_settings/default",
    headers: { apiVersion: 1 }
  });

export const fetchAccount = (accountId: Id): Promise<Account> =>
  api({
    url: `saas_admin/accounts/${accountId}`,
    headers: { apiVersion: 1 }
  });

export const createAccount = (accountData: EditAccountForm): Promise<Account> =>
  api({
    url: "saas_admin/accounts",
    method: "POST",
    headers: { apiVersion: 1 },
    data: parsePayload(accountData)
  });

export const removeAccount = (accountId: Id) =>
  api({
    url: `saas_admin/accounts/${accountId}`,
    method: "DELETE",
    headers: { apiVersion: 1 }
  });

export const updateAccount = (accountId: number, accountData: EditAccountForm) =>
  api({
    url: `saas_admin/accounts/${accountId}`,
    method: "PUT",
    headers: { apiVersion: 1 },
    data: parsePayload(accountData)
  });

export const fetchCategoryOptions = (
  type: CategoryType,
  term: string,
  accountId?: number
): Promise<Category[]> =>
  api({
    url: `options/categories/${type}`,
    params: {
      accountId,
      term,
      _: Date.now()
    }
  });

export const fetchCustomization = (accountId: Id | undefined): Promise<any> =>
  api({
    url: `saas_admin/accounts/${accountId}/customization`,
    headers: { apiVersion: 1 }
  });

export const updateCustomization = (accountId: Id, data: any): Promise<any> =>
  api({
    url: `saas_admin/accounts/${accountId}/customization`,
    method: "PUT",
    headers: { apiVersion: 1 },
    data
  });

export const exportAccountConfig = (accountId: number) =>
  api({
    url: `accounts/${accountId}/export`
  });

export const importAccountConfig = (accountId: number, data): Promise<void> =>
  api({
    method: "POST",
    url: `accounts/${accountId}/import`,
    data
  });

export const fetchCvParserConfig = (accountId: Id) => api({ url: `accounts/${accountId}/cv_parser_config` });

export const updateCvParsingConfig = (accountId: Id, data) =>
  api({ url: `accounts/${accountId}/cv_parser_config`, method: "PUT", data });
